import React, { useState } from "react";
import "./styles.css";

const emojiDictionary = {
  "🤗": "Hugging Face",
  "😲": "Astonished Face",
  "🥰": "Smiling Face with Hearts",
  "😘": "Face Blowing a Kiss",
  "😋": "Face Savoring Food",
  "😕": "Confused Face",
  "💯":":100:",
  "🔢":":1234:",
  "😄":":smile:",
  "😀":":grinning:",
  "😃":":smiley:",
  "😊":":blush:",
  "☺":":relaxed:",
  "😉":":wink:",
  "😍":":heart_eyes:",
  "😘":":kissing_heart:",
  "😚":":kissing_closed_eyes:",
  "😗":":kissing:",
  "😙":":kissing_smiling_eyes:",
  "😜":":stuck_out_tongue_winking_eye:",
  "😝":":stuck_out_tongue_closed_eyes:",
  "😛":":stuck_out_tongue:",
  "😳":":flushed:",
  "😁":":grin:",
  "😔":":pensive:",
  "😥":":relieved:",
  "😒":":unamused:",
  "😞":":disappointed:",
  "😣":":persevere:",
  "😢":":cry:",
  "😂":":joy:",
  "😭":":sob:",
  "😪":":sleepy:",
  "":":fu:",
  "😰":":cold_sweat:",
  "😅":":sweat_smile:",
  "😓":":sweat:",
  "😩":":weary:",
  "😫":":tired_face:",
  "😨":":fearful:",
  "😱":":scream:",
  "😠":":angry:",
  "😤":":triumph:",
  "😖":":confounded:",
  "😌":":satisfied:",
  "😋":":yum:",
  "😷":":mask:",
  "😎":":sunglasses:",
  "😴":":sleeping:",
  "😵":":dizzy_face:",
  "😲":":astonished:",
  "😟":":worried:",
  "😦":":frowning:",
  "😧":":anguished:",
  "😈":":smiling_imp:",
  "👿":":imp:",
  "😮":":open_mouth:",
  "😬":":grimacing:",
  "😐":":neutral_face:",
  "😕":":confused:",
  "😯":":hushed:",
  "😶":":no_mouth:",
  "😇":":innocent:",
  "😏":":smirk:",
  "😑":":expressionless:",
  "👲":":man_with_gua_pi_mao:",
  "👳":":man_with_turban:",
  "👮":":cop:",
  "👷":":construction_worker:",
  "💂":":guardsman:",
  "👶":":baby:",
  "👦":":boy:",
  "👧":":girl:",
  "👨":":man:",
  "👩":":woman:",
  "👴":":older_man:",
  "👵":":older_woman:",
  "👱":":person_with_blond_hair:",
  "👼":":angel:",
  "👸":":princess:",
  "😸":":smile_cat:",
  "😻":":heart_eyes_cat:",
  "😽":":kissing_cat:",
  "😼":":smirk_cat:",
  "🙀":":scream_cat:",
  "😿":":crying_cat_face:",
  "😹":":joy_cat:",
  "😾":":pouting_cat:",
  "😺":":smiley_cat:",
  "👺":":japanese_goblin:",
  "🙈":":see_no_evil:",
  "🙉":":hear_no_evil:",
  "🙊":":speak_no_evil:",
  "💀":":skull:",
  "👽":":alien:",
  "💩":":shit:",
  "🔥":":fire:",
  "✨":":sparkles:",
  "🌟":":star2:",
  "💫":":dizzy:",
  "💥":":collision:",
  "💢":":anger:",
  "💦":":sweat_drops:",
  "💧":":droplet:",
  "💤":":zzz:",
  "👂":":ear:",
  "👀":":eyes:",
  "👃":":nose:",
  "👅":":tongue:",
  "👄":":lips:",
  "👍":":thumbsup:",
  "👎":":thumbsdown:",
  "👌":":ok_hand:",
  "👊":":facepunch:",
  "✊":":fist:",
  "✌":":v:",
  "👋":":wave:",
  "✋":":hand:",
  "👐":":open_hands:",
  "☝":":point_up:",
  "👇":":point_down:",
  "👉":":point_right:",
  "👈":":point_left:",
  "🙌":":raised_hands:",
  "🙏":":pray:",
  "👆":":point_up_2:",
  "👏":":clap:",
  "💪":":muscle:",
  "🚶":":walking:",
  "🏃":":running:",
  "💃":":dancer:",
  "👫":":couple:",
  "👪":":family:",
  "👬":":two_men_holding_hands:",
  "👭":":two_women_holding_hands:",
  "💏":":couplekiss:",
  "💑":":couple_with_heart:",
  "👯":":dancers:",
  "🙆":":ok_woman:",
  "🙅":":no_good:",
  "💁":":information_desk_person:",
  "🙋":":raised_hand:",
  "💆":":massage:",
  "💇":":haircut:",
  "💅":":nail_care:",
  "👰":":bride_with_veil:",
  "🙎":":person_with_pouting_face:",
  "🙍":":person_frowning:",
  "🙇":":bow:",
  "🎩":":tophat:",
  "👑":":crown:",
  "👒":":womans_hat:",
  "👞":":mans_shoe:",
  "👡":":sandal:",
  "👠":":high_heel:",
  "👢":":boot:",
  "👕":":shirt:",
  "👔":":necktie:",
  "👚":":womans_clothes:",
  "👗":":dress:",
  "🎽":":running_shirt_with_sash:",
  "👖":":jeans:",
  "👘":":kimono:",
  "👙":":bikini:",
  "💼":":briefcase:",
  "👜":":handbag:",
  "👝":":pouch:",
  "👛":":purse:",
  "👓":":eyeglasses:",
  "🎀":":ribbon:",
  "🌂":":closed_umbrella:",
  "💄":":lipstick:",
  "💛":":yellow_heart:",
  "💙":":blue_heart:",
  "💜":":purple_heart:",
  "💚":":green_heart:",
  "❤":":heart:",
  "💔":":broken_heart:",
  "💗":":heartpulse:",
  "💓":":heartbeat:",
  "💕":":two_hearts:",
  "💖":":sparkling_heart:",
  "💞":":revolving_hearts:",
  "💘":":cupid:",
  "💌":":love_letter:",
  "💋":":kiss:",
  "💍":":ring:",
  "💎":":gem:",
  "👤":":bust_in_silhouette:",
  "👥":":busts_in_silhouette:",
  "💬":":speech_balloon:",
  "💭":":thought_balloon:",
  "🐶":":dog:",
  "🐺":":wolf:",
  "🐱":":cat:",
  "🐭":":mouse:",
  "🐹":":hamster:",
  "🐰":":rabbit:",
  "🐸":":frog:",
  "🐯":":tiger:",
  "🐨":":koala:",
  "🐻":":bear:",
  "🐷":":pig:",
  "🐽":":pig_nose:",
  "🐮":":cow:",
  "🐗":":boar:",
  "🐒":":monkey:",
  "🐵":":monkey_face:",
  "🐴":":horse:",
  "🐑":":sheep:",
  "🐘":":elephant:",
  "🐼":":panda_face:",
  "🐧":":penguin:",
  "🐦":":bird:",
  "🐤":":baby_chick:",
  "🐥":":hatched_chick:",
  "🐣":":hatching_chick:",
  "🐔":":chicken:",
  "🐍":":snake:",
  "🐢":":turtle:",
  "🐛":":bug:",
  "🐝":":honeybee:",
  "🐜":":ant:",
  "🐞":":beetle:",
  "🐌":":snail:",
  "🐙":":octopus:",
  "🐚":":shell:",
  "🐠":":tropical_fish:",
  "🐟":":fish:",
  "🐬":":dolphin:",
  "🐳":":whale:",
  "🐋":":whale2:",
  "🐄":":cow2:",
  "🐏":":ram:",
  "🐀":":rat:",
  "🐃":":water_buffalo:",
  "🐅":":tiger2:",
  "🐇":":rabbit2:",
  "🐉":":dragon:",
  "🐎":":racehorse:",
  "🐐":":goat:",
  "🐓":":rooster:",
  "🐕":":dog2:",
  "🐖":":pig2:",
  "🐁":":mouse2:",
  "🐂":":ox:",
  "🐲":":dragon_face:",
  "🐡":":blowfish:",
  "🐊":":crocodile:",
  "🐫":":camel:",
  "🐪":":dromedary_camel:",
  "🐆":":leopard:",
  "🐈":":cat2:",
  "🐩":":poodle:",
  "🐾":":paw_prints:",
  "💐":":bouquet:",
  "🌸":":cherry_blossom:",
  "🌷":":tulip:",
  "🍀":":four_leaf_clover:",
  "🌹":":rose:",
  "🌻":":sunflower:",
  "🌺":":hibiscus:",
  "🍁":":maple_leaf:",
  "🍃":":leaves:",
  "🍂":":fallen_leaf:",
  "🌿":":herb:",
  "🌾":":ear_of_rice:",
  "🍄":":mushroom:",
  "🌵":":cactus:",
  "🌴":":palm_tree:",
  "🌲":":evergreen_tree:",
  "🌳":":deciduous_tree:",
  "🌰":":chestnut:",
  "🌱":":seedling:",
  "🌼":":blossom:",
  "🌐":":globe_with_meridians:",
  "🌞":":sun_with_face:",
  "🌝":":full_moon_with_face:",
  "🌚":":new_moon_with_face:",
  "🌑":":new_moon:",
  "🌒":":waxing_crescent_moon:",
  "🌓":":first_quarter_moon:",
  "🌙":":moon:",
  "🌕":":full_moon:",
  "🌖":":waning_gibbous_moon:",
  "🌗":":last_quarter_moon:",
  "🌘":":waning_crescent_moon:",
  "🌜":":last_quarter_moon_with_face:",
  "🌛":":first_quarter_moon_with_face:",
  "🌍":":earth_africa:",
  "🌎":":earth_americas:",
  "🌏":":earth_asia:",
  "🌋":":volcano:",
  "🌌":":milky_way:",
  "🌃":":stars:",
  "⭐":":star:",
  "☀":":sunny:",
  "⛅":":partly_sunny:",
  "☁":":cloud:",
  "⚡":":zap:",
  "☔":":umbrella:",
  "❄":":snowflake:",
  "⛄":":snowman:",
  "🌀":":cyclone:",
  "🌁":":foggy:",
  "🌈":":rainbow:",
  "🌊":":ocean:",
  "🎱":":8ball:",
  "🅰":":a:",
  "🆎":":ab:",
  "🔤":":abc:",
  "🔡":":abcd:",
  "🉑":":accept:",
  "🚡":":aerial_tramway:",
  "✈":":airplane:",
  "⏰":":alarm_clock:",
  "🚑":":ambulance:",
  "⚓":":anchor:",
  "🕖":":clock7:",
  "🕢":":clock730:",
  "🕗":":clock8:",
  "🕣":":clock830:",
  "🕘":":clock9:",
  "🕤":":clock930:",
  "📕":":closed_book:",
  "🔐":":closed_lock_with_key:",
  "♣":":clubs:",
  "🇨🇳":":cn:",
  "🍸":":cocktail:",
  "☕":":coffee:",
  "💻":":computer:",
  "🎊":":confetti_ball:",
  "#️⃣":":hash:",
  "🎧":":headphones:",
  "💟":":heart_decoration:",
  "♥":":hearts:",
  "✔":":heavy_check_mark:",
  "➗":":heavy_division_sign:",
  "💲":":heavy_dollar_sign:",
  "➖":":heavy_minus_sign:",
  "✖":":heavy_multiplication_x:",
  "🎶":":notes:",
  "🔩":":nut_and_bolt:",
  "⭕":":o:",
  "🅾":":o2:",
  "🍢":":oden:",
  "🏢":":office:",
  "🆗":":ok:",
  "🔛":":on:",
  "🚘":":oncoming_automobile:",
  "🚍":":oncoming_bus:",
  "🚔":":oncoming_police_car:",
  "🚖":":oncoming_taxi:",
  "1️⃣":":one:",
  "🚬":":smoking:",
  "🏂":":snowboarder:",
  "⚽":":soccer:",
  "🔜":":soon:",
  "🆘":":sos:",
  "🔉":":sound:",
  "👾":":space_invader:",
  "♠":":spades:",
  "🍝":":spaghetti:",
  "🎇":":sparkler:",
  "㊗":":congratulations:",
  "➕":":heavy_plus_sign:",
  "🍎":":apple:",
  "🚧":":construction:",
  "🚁":":helicopter:",
  "📂":":open_file_folder:",
  "🔊":":speaker:",
  "♒":":aquarius:",
  "♈":":aries:",
  "🏪":":convenience_store:",
  "🚤":":speedboat:",
  "◀":":arrow_backward:",
  "🍪":":cookie:",
  "🔆":":high_brightness:",
  "⛎":":ophiuchus:",
  "⏬":":arrow_double_down:",
  "🆒":":cool:",
  "📙":":orange_book:",
  "⏫":":arrow_double_up:",
  "🔪":":hocho:",
  "📤":":outbox_tray:",
  "⬇":":arrow_down:",
  "©":":copyright:",
  "🍯":":honey_pot:",
  "🔽":":arrow_down_small:",
  "🌽":":corn:",
  "🚉":":station:",
  "▶":":arrow_forward:",
  "📄":":page_facing_up:",
  "🗽":":statue_of_liberty:",
  "⤵":":arrow_heading_down:",
  "📃":":page_with_curl:",
  "🚂":":steam_locomotive:",
  "⤴":":arrow_heading_up:",
  "🏥":":hospital:",
  "📟":":pager:",
  "🍲":":stew:",
  "⬅":":arrow_left:",
  "🏨":":hotel:",
  "📏":":straight_ruler:",
  "↙":":arrow_lower_left:",
  "♨":":hotsprings:",
  "🍓":":strawberry:",
  "↘":":arrow_lower_right:",
  "💳":":credit_card:",
  "⌛":":hourglass:",
  "📎":":paperclip:",
  "➡":":arrow_right:",
  "⏳":":hourglass_flowing_sand:",
  "🅿":":parking:",
  "↪":":arrow_right_hook:",
  "🏠":":house:",
  "〽":":part_alternation_mark:",
  "⬆":":arrow_up:",
  "🎌":":crossed_flags:",
  "🏡":":house_with_garden:",
  "↕":":arrow_up_down:",
  "🛂":":passport_control:",
  "🔼":":arrow_up_small:",
  "↖":":arrow_upper_left:",
  "🍨":":ice_cream:",
  "🍑":":peach:",
  "↗":":arrow_upper_right:",
  "🔮":":crystal_ball:",
  "🍦":":icecream:",
  "🍐":":pear:",
  "🌅":":sunrise:",
  "🔃":":arrows_clockwise:",
  "🆔":":id:",
  "📝":":memo:",
  "🌄":":sunrise_over_mountains:",
  "🔄":":arrows_counterclockwise:",
  "➰":":curly_loop:",
  "🉐":":ideograph_advantage:",
  "✏":":pencil2:",
  "🏄":":surfer:",
  "🎨":":art:",
  "💱":":currency_exchange:",
  "🍣":":sushi:",
  "🚛":":articulated_lorry:",
  "🍛":":curry:",
  "📥":":inbox_tray:",
  "🍮":":custard:",
  "📨":":incoming_envelope:",
  "🎭":":performing_arts:",
  "🚟":":suspension_railway:",
  "🛃":":customs:",
  "🏧":":atm:",
  "ℹ":":information_source:",
  "🅱":":b:",
  "⁉":":interrobang:",
  "🍠":":sweet_potato:",
  "🍼":":baby_bottle:",
  "🍡":":dango:",
  "📱":":iphone:",
  "☎":":telephone:",
  "🏊":":swimmer:",
  "🎯":":dart:",
  "🇮🇹":":it:",
  "🔣":":symbols:",
  "🚼":":baby_symbol:",
  "💨":":dash:",
  "💉":":syringe:",
  "📅":":date:",
  "🎃":":jack_o_lantern:",
  "🎉":":tada:",
  "🛄":":baggage_claim:",
  "🇩🇪":":de:",
  "🗾":":japan:",
  "💊":":pill:",
  "🎋":":tanabata_tree:",
  "🎈":":balloon:",
  "🏯":":japanese_castle:",
  "🍍":":pineapple:",
  "🍊":":tangerine:",
  "☑":":ballot_box_with_check:",
  "🏬":":department_store:",
  "♓":":pisces:",
  "♉":":taurus:",
  "🎍":":bamboo:",
  "💠":":diamond_shape_with_a_dot_inside:",
  "👹":":japanese_ogre:",
  "🍕":":pizza:",
  "🚕":":taxi:",
  "🍌":":banana:",
  "♦":":diamonds:",
  "🍵":":tea:",
  "‼":":bangbang:",
  "🏦":":bank:",
  "📞":":telephone_receiver:",
  "📊":":bar_chart:",
  "🇯🇵":":jp:",
  "🔭":":telescope:",
  "💈":":barber:",
  "🔑":":key:",
  "🎾":":tennis:",
  "⚾":":baseball:",
  "🚯":":do_not_litter:",
  "🔟":":keycap_ten:",
  "🚓":":police_car:",
  "⛺":":tent:",
  "🏀":":basketball:",
  "🛀":":bath:",
  "3️⃣":":three:",
  "🛁":":bathtub:",
  "💵":":dollar:",
  "🏣":":post_office:",
  "🔋":":battery:",
  "🎎":":dolls:",
  "📯":":postal_horn:",
  "📮":":postbox:",
  "🎫":":ticket:",
  "🚪":":door:",
  "🚰":":potable_water:",
  "🍺":":beer:",
  "🍩":":doughnut:",
  "🍻":":beers:",
  "🍗":":poultry_leg:",
  "🈁":":koko:",
  "💷":":pound:",
  "™":":tm:",
  "🔰":":beginner:",
  "🇰🇷":":kr:",
  "🚽":":toilet:",
  "🔔":":bell:",
  "🗼":":tokyo_tower:",
  "🍱":":bento:",
  "🔵":":large_blue_circle:",
  "🍅":":tomato:",
  "🚴":":bicyclist:",
  "📀":":dvd:",
  "🔷":":large_blue_diamond:",
  "🚲":":bike:",
  "📧":":e-mail:",
  "🔶":":large_orange_diamond:",
  "🔝":":top:",
  "📌":":pushpin:",
  "🚜":":tractor:",
  "🎂":":birthday:",
  "😆":":laughing:",
  "🚮":":put_litter_in_its_place:",
  "🚥":":traffic_light:",
  "⚫":":black_circle:",
  "❓":":question:",
  "🚃":":railway_car:",
  "🃏":":black_joker:",
  "📒":":ledger:",
  "🚆":":train2:",
  "🍳":":egg:",
  "🛅":":left_luggage:",
  "🚊":":tram:",
  "🍆":":eggplant:",
  "↔":":left_right_arrow:",
  "🚩":":triangular_flag_on_post:",
  "8️⃣":":eight:",
  "↩":":leftwards_arrow_with_hook:",
  "📻":":radio:",
  "📐":":triangular_ruler:",
  "✒":":black_nib:",
  "✴":":eight_pointed_black_star:",
  "🍋":":lemon:",
  "🔘":":radio_button:",
  "🔱":":trident:",
  "✳":":eight_spoked_asterisk:",
  "♌":":leo:",
  "😡":":rage:",
  "🔲":":black_square_button:",
  "🔌":":electric_plug:",
  "🚎":":trolleybus:",
  "♎":":libra:",
  "✉":":envelope:",
  "🚈":":light_rail:",
  "🏆":":trophy:",
  "📘":":blue_book:",
  "🔚":":end:",
  "🔗":":link:",
  "🍹":":tropical_drink:",
  "🚙":":blue_car:",
  "🚚":":truck:",
  "🇪🇸":":es:",
  "🔒":":lock:",
  "🎺":":trumpet:",
  "💶":":euro:",
  "🔏":":lock_with_ink_pen:",
  "⛵":":sailboat:",
  "🏰":":european_castle:",
  "🍭":":lollipop:",
  "💣":":bomb:",
  "🏤":":european_post_office:",
  "➿":":loop:",
  "📢":":loudspeaker:",
  "🍜":":ramen:",
  "📺":":tv:",
  "🔖":":bookmark:",
  "❗":":exclamation:",
  "🏩":":love_hotel:",
  "🔀":":twisted_rightwards_arrows:",
  "📑":":bookmark_tabs:",
  "♻":":recycle:",
  "2️⃣":":two:",
  "📚":":books:",
  "🔅":":low_brightness:",
  "🚗":":car:",
  "Ⓜ":":m:",
  "🔴":":red_circle:",
  "🔍":":mag:",
  "®":":registered:",
  "🏭":":factory:",
  "🔎":":mag_right:",
  "🈹":":u5272:",
  "🀄":":mahjong:",
  "🈴":":u5408:",
  "🎳":":bowling:",
  "📫":":mailbox:",
  "🔁":":repeat:",
  "🈺":":u55b6:",
  "⏩":":fast_forward:",
  "📪":":mailbox_closed:",
  "🔂":":repeat_one:",
  "🈯":":u6307:",
  "📠":":fax:",
  "📬":":mailbox_with_mail:",
  "🚻":":restroom:",
  "🈷":":u6708:",
  "🍞":":bread:",
  "📭":":mailbox_with_no_mail:",
  "🈶":":u6709:",
  "⏪":":rewind:",
  "🈵":":u6e80:",
  "🌉":":bridge_at_night:",
  "👣":":feet:",
  "🈚":":u7121:",
  "🎡":":ferris_wheel:",
  "🍚":":rice:",
  "🈸":":u7533:",
  "📁":":file_folder:",
  "🍙":":rice_ball:",
  "🈲":":u7981:",
  "🍘":":rice_cracker:",
  "🈳":":u7a7a:",
  "💡":":bulb:",
  "🎑":":rice_scene:",
  "🇬🇧":":gb:",
  "🚅":":bullettrain_front:",
  "🚒":":fire_engine:",
  "🚄":":bullettrain_side:",
  "🎆":":fireworks:",
  "🍖":":meat_on_bone:",
  "🚀":":rocket:",
  "🚌":":bus:",
  "📣":":mega:",
  "🎢":":roller_coaster:",
  "🔞":":underage:",
  "🚏":":busstop:",
  "🍈":":melon:",
  "🔓":":unlock:",
  "🍥":":fish_cake:",
  "🚹":":mens:",
  "🚨":":rotating_light:",
  "🆙":":up:",
  "🎣":":fishing_pole_and_fish:",
  "📍":":round_pushpin:",
  "🇺🇸":":us:",
  "🍰":":cake:",
  "🚇":":metro:",
  "🚣":":rowboat:",
  "📆":":calendar:",
  "5️⃣":":five:",
  "🎤":":microphone:",
  "🇷🇺":":ru:",
  "🚦":":vertical_traffic_light:",
  "📲":":calling:",
  "🎏":":flags:",
  "🔬":":microscope:",
  "🏉":":rugby_football:",
  "📼":":vhs:",
  "🔦":":flashlight:",
  "📳":":vibration_mode:",
  "📷":":camera:",
  "💾":":floppy_disk:",
  "🚐":":minibus:",
  "📹":":video_camera:",
  "♋":":cancer:",
  "🎴":":flower_playing_cards:",
  "💽":":minidisc:",
  "🎮":":video_game:",
  "🍬":":candy:",
  "📴":":mobile_phone_off:",
  "🈂":":sa:",
  "🎻":":violin:",
  "🔠":":capital_abcd:",
  "💸":":money_with_wings:",
  "♐":":sagittarius:",
  "♍":":virgo:",
  "♑":":capricorn:",
  "🏈":":football:",
  "💰":":moneybag:",
  "🍶":":sake:",
  "🆚":":vs:",
  "📇":":card_index:",
  "🍴":":fork_and_knife:",
  "🎠":":carousel_horse:",
  "⛲":":fountain:",
  "🚝":":monorail:",
  "🎅":":santa:",
  "4️⃣":":four:",
  "📡":":satellite:",
  "🎓":":mortar_board:",
  "⚠":":warning:",
  "💿":":cd:",
  "🇫🇷":":fr:",
  "🗻":":mount_fuji:",
  "🎷":":saxophone:",
  "⌚":":watch:",
  "💹":":chart:",
  "🆓":":free:",
  "🚵":":mountain_bicyclist:",
  "🏫":":school:",
  "📉":":chart_with_downwards_trend:",
  "🍤":":fried_shrimp:",
  "🚠":":mountain_cableway:",
  "🎒":":school_satchel:",
  "🍉":":watermelon:",
  "📈":":chart_with_upwards_trend:",
  "🍟":":fries:",
  "🚞":":mountain_railway:",
  "✂":":scissors:",
  "🏁":":checkered_flag:",
  "♏":":scorpius:",
  "〰":":wavy_dash:",
  "🍒":":cherries:",
  "⛽":":fuelpump:",
  "🎥":":movie_camera:",
  "🌔":":waxing_gibbous_moon:",
  "🗿":":moyai:",
  "📜":":scroll:",
  "🚾":":wc:",
  "💺":":seat:",
  "🚸":":children_crossing:",
  "🎲":":game_die:",
  "㊙":":secret:",
  "💒":":wedding:",
  "🍫":":chocolate_bar:",
  "🎹":":musical_keyboard:",
  "🎵":":musical_note:",
  "⛪":":church:",
  "♊":":gemini:",
  "🎼":":musical_score:",
  "7️⃣":":seven:",
  "♿":":wheelchair:",
  "🎦":":cinema:",
  "👻":":ghost:",
  "🔇":":mute:",
  "🍧":":shaved_ice:",
  "✅":":white_check_mark:",
  "🎪":":circus_tent:",
  "🎁":":gift:",
  "⚪":":white_circle:",
  "🌇":":city_sunrise:",
  "💝":":gift_heart:",
  "📛":":name_badge:",
  "💮":":white_flower:",
  "🌆":":city_sunset:",
  "🚢":":ship:",
  "🆑":":cl:",
  "❎":":negative_squared_cross_mark:",
  "🎬":":clapper:",
  "📋":":clipboard:",
  "🆕":":new:",
  "🔳":":white_square_button:",
  "🕐":":clock1:",
  "⛳":":golf:",
  "🚿":":shower:",
  "🎐":":wind_chime:",
  "🕙":":clock10:",
  "🍇":":grapes:",
  "📶":":signal_strength:",
  "🍷":":wine_glass:",
  "🕥":":clock1030:",
  "🍏":":green_apple:",
  "📰":":newspaper:",
  "6️⃣":":six:",
  "🕚":":clock11:",
  "📗":":green_book:",
  "🆖":":ng:",
  "🔯":":six_pointed_star:",
  "🕦":":clock1130:",
  "9️⃣":":nine:",
  "🎿":":ski:",
  "🕛":":clock12:",
  "❕":":grey_exclamation:",
  "🔕":":no_bell:",
  "🕧":":clock1230:",
  "❔":":grey_question:",
  "🚳":":no_bicycles:",
  "🕜":":clock130:",
  "⛔":":no_entry:",
  "🚺":":womens:",
  "🕑":":clock2:",
  "🚫":":no_entry_sign:",
  "🎰":":slot_machine:",
  "🕝":":clock230:",
  "🔹":":small_blue_diamond:",
  "🔧":":wrench:",
  "🕒":":clock3:",
  "📵":":no_mobile_phones:",
  "🔸":":small_orange_diamond:",
  "❌":":x:",
  "🕞":":clock330:",
  "🎸":":guitar:",
  "🔺":":small_red_triangle:",
  "🕓":":clock4:",
  "🔫":":gun:",
  "🚷":":no_pedestrians:",
  "🔻":":small_red_triangle_down:",
  "💴":":yen:",
  "🕟":":clock430:",
  "🚭":":no_smoking:",
  "🕔":":clock5:",
  "🍔":":hamburger:",
  "🚱":":non-potable_water:",
  "🕠":":clock530:",
  "🔨":":hammer:",
  "0️⃣":":zero:",
  "🕕":":clock6:",
  "📓":":notebook:",
  "🕡":":clock630:",
  "📔":":notebook_with_decorative_cover:",
  "🏇":":horse_racing:",
  "🎄":":christmas_tree:"
};


var emojiWeKnow = Object.keys(emojiDictionary);
export default function App() {
var [meaning, setMeaning] = useState("");

function emojiInputHandler(event)
{
  var userInput = event.target.value;
  var meaning = emojiDictionary[userInput];
  if(meaning === undefined)
  {
    meaning= " We don't have this in our database."
  }
  setMeaning (meaning);
}

function emojiClickHandler(emoji)
{
  var meaning = emojiDictionary[emoji];
  setMeaning(meaning);
}
  return (
    <div className="App">
          <h1>Emoji Interpreter</h1>
          <input onChange={emojiInputHandler}></input>
        <h2> {meaning} </h2>
        <h3> emojis we know </h3>
        {emojiWeKnow.map(function(emoji){
            return (
               <span 
               onClick= {()=> emojiClickHandler(emoji)}
               style={{ fontSize: "2rem" ,padding: "0.5rem", cursor:"pointer" }} key={emoji} > {emoji}{" "} </span>
            );
           })}
    </div>
  );
}

//Viser-- view -> Interact -> State in event Handler -> Render

